import { Routes, Route, Navigate, Link } from 'react-router-dom'
import {
  AppBar, Box, Drawer, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Toolbar, Typography
} from '@mui/material'
import DashboardIcon from '@mui/icons-material/Dashboard'
import ShowChartIcon from '@mui/icons-material/ShowChart'
import TableChartIcon from '@mui/icons-material/TableChart'
import TuneIcon from '@mui/icons-material/Tune'
import PortfolioDashboard from './components/Portfolio/PortfolioDashboard'
import TradeList from './components/Trades/TradeList'
import TradeForm from './components/Trades/TradeForm'
import TradingChart from './components/Charts/TradingChart'
import MMPanel from './components/MM/MMPanel'

const DRAWER_WIDTH = 220

const navItems = [
  { label: 'Dashboard',   path: '/dashboard',   icon: <DashboardIcon /> },
  { label: 'Trades',      path: '/trades',       icon: <TableChartIcon /> },
  { label: 'Chart',       path: '/chart',        icon: <ShowChartIcon /> },
  { label: 'MM / Sizing', path: '/mm',           icon: <TuneIcon /> },
]

export default function App() {
  return (
    <Box sx={{ display: 'flex' }}>
      {/* ── Sidebar ── */}
      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' },
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap sx={{ fontWeight: 700 }}>
            📈 TradePlatform
          </Typography>
        </Toolbar>
        <List>
          {navItems.map((item) => (
            <ListItem key={item.path} disablePadding>
              <ListItemButton component={Link} to={item.path}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* ── Main content ── */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <AppBar
          position="fixed"
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, width: `calc(100% - ${DRAWER_WIDTH}px)`, ml: `${DRAWER_WIDTH}px` }}
        >
          <Toolbar>
            <Typography variant="h6" component="div">
              Trading Analysis Platform
            </Typography>
          </Toolbar>
        </AppBar>
        <Toolbar />

        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<PortfolioDashboard />} />
          <Route path="/trades" element={<TradeList />} />
          <Route path="/trades/new" element={<TradeForm />} />
          <Route path="/chart" element={<TradingChart />} />
          <Route path="/mm" element={<MMPanel />} />
        </Routes>
      </Box>
    </Box>
  )
}
